module.exports = __webpack_public_path__ + "static/img/yichu.f4b0506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/yichu.png
// module id = koWS
// module chunks = 24